import React from "react";

interface ILinkContext {
    target: string | undefined;
}

export const linkContext = React.createContext<ILinkContext>({ target: undefined });

interface ProviderProps {
    target?: string;
    children: React.ReactNode;
}

const Provider = linkContext.Provider;
export const LinkContextProvider = ({ target, children }: ProviderProps) => (
    <Provider value={{ target }}>{children}</Provider>
);
